import { motion } from "framer-motion";

const AdvisoryCard = ({ person }) => {
  const { name, designation, image } = person;

  // Split designation by "|" to handle multiple roles (e.g., Dr. Sandeep Marwah)
  const roles = designation.split("|").map((role) => role.trim());

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ type: "spring", stiffness: 300 }}
      className="group relative bg-white rounded-2xl shadow-md 
                 border border-gray-100 
                 hover:shadow-xl hover:border-blue-200
                 transition-all duration-300 
                 h-[290px] flex flex-col items-center 
                 p-6 overflow-hidden"
    >

      
      {/* Subtle gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-blue-50/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

      {/* Image with refined border and subtle shadow */}
      <div className="relative w-32 h-32 mb-4 overflow-hidden rounded-2xl shadow-md 
                      ring-2 ring-offset-2 ring-offset-white ring-blue-100 group-hover:ring-blue-300 transition-all">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Name */}
      <h3 className="text-lg font-semibold text-gray-900 text-center leading-tight min-h-[56px] flex items-center">
        {name}
      </h3>

      {/* Designation(s) */}
      <div className="flex-1 flex flex-col justify-start items-center w-full mt-1 space-y-1">
        {roles.map((role, idx) => (
          <p
            key={idx}
            className="text-xs text-gray-600 text-center leading-relaxed px-2 
                       border-b border-dotted border-gray-200 pb-1 last:border-0"
          >
            {role}
          </p>
        ))}
      </div>

      {/* Decorative element – subtle line */}
      <div className="mt-3 w-12 h-[2px] bg-gradient-to-r from-blue-300 to-indigo-400 rounded-full" />
    </motion.div>
  );
};

export default AdvisoryCard;